import { ParalegalPartTimeUrl, BasketCartUrl } from "../directives/utilities/urls";

export default function declarationofCandidacy() {
    return {
        isClearBalancePaymentBasket: false,
        isCandidacyVerification: false,
        candidacyVerificationFalseMessage: '',
        eValue:'',
        message: '',
        isSuccessMessage: false,
        selectedCandidacyOptions: '',
        selectedCandidacyOption: '',
        checkOutMessage:'',
        candidacyOptions:[],
        SaveDeclareCandidacy() {
            if (this.selectedCandidacyOptions == '') {
                this.message = "Please select one option from drop down";
            }
            else {
                this.isPassedEmail = false;
                this.isPassedEmailError = "";
                if (this.selectedCandidacyOptions == 'PARAL' || this.selectedCandidacyOptions == 'PARALC') {
                    window.location.href = ParalegalPartTimeUrl + "?id=" + this.selectedCandidacyOptions;
                    return true;
                } else {
                    fetch('/api/Basket/declare-candidacy', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            SessionId: "",
                            CandidacyOption: this.selectedCandidacyOptions
                        })
                    })
                        .then(response => {
                            if (response.ok) {
                                return response.json()
                            }
                        }).then(response => {
                            if (response.isSuccess) {

                                this.isSuccessMessage = true;
                                window.location.href = BasketCartUrl;

                                // this.message = "Information with email form saved successfully";
                            }
                            else if (!response.isSuccess && response.checkoutTypeError) {
                                this.checkOutMessage = response.message
                                document.getElementById('btnCartCheckOutError').click();
                            } 
                            else {
                                this.isSuccessMessage = false;
                                this.message = response.messages.length > 0 ? response.messages[0] : "Something went wrong";

                            }

                        });
                }
                
                
                

            }

        },
        CandidacyVerificationRequestCheck() {

            fetch('/api/Basket/CandidacyVerificationRequestCheck', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
              
                    if (response != undefined && response.isSuccess && response.allowed) {

                        this.isCandidacyVerification = true;
                        this.candidacyVerificationFalseMessage = "";
                    } else {
                        this.isCandidacyVerification = false;
                     
                        this.candidacyVerificationFalseMessage = response.message;

                    }

                });
        },
        getCandidacyOptions() {
            fetch('/api/common/candidacy-options')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    
                    this.candidacyOptions = json
                })
                .catch((error) => {
                    console.error(error);
                })
        },
      
        ClearBalancePaymentBasket() {

            fetch('/api/Basket/ClearBalancePaymentBasket', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.isClearBalancePaymentBasket = true;
                        this.CandidacyVerificationRequestCheck();
                    } else {
                        this.isClearBalancePaymentBasket = false;
                    }

                });
        },
        init() {
          
            const urlParams = new URLSearchParams(window.location.search);
            const basketId = urlParams.get('e');
            this.selectedCandidacyOption = urlParams.get('id');
          
            this.CandidacyVerificationRequestCheck();
            this.getCandidacyOptions();
            this.passedBasketId = document.getElementById("BasketId").value;
       
            
        }
    }
}